import { fetchMessages, fetchMessageThread, fetchMessageThreadCount, sendMessage, updatemessage, checkConnection, readMessage, fetchParticipantInfo, fetchParticipantConsent, updatemyconsents } from '../api'
import Vue from 'vue'

export const listenForMessages = ({ commit, state }, data) => {
  Vue.$socketApi.initListener('nutricom.MessagingParticipant:state:chatting', data)
}

export const listenForSignups = ({ commit, state }, data) => {
  Vue.$socketApi.initListener('nutricom.SignupListener:state:listening', data)
}

export const doReadMessage = ({ commit, state }, data) => {
  if (data && data.agentData) {
    readMessage(data)
  }
}

export const setActiveThread = ({ commit, state }, data) => {
  if (data) {
    commit('ACTIVE_THREAD', data)
  }
}

export const addMessageListener = ({ commit, state }, data) => {
  if (data) {
    commit('NEW_MESSAGE_LISTENER', data)
  }
}

export const isConnected = ({ commit, state }, data) => {
  checkConnection(data)
}

export const setCanSend = ({ commit, state }, data) => {
  commit('SET_CAN_SEND', data)
}

export const loadAvatars = async ({ commit, state }, message) => {
  const participants = state.participants
  for (let i = 0; i < message.participants.length; i++) {
    const participantsFound = participants.filter(participant => message.participants[i]._id === participant._id)
    if (!participantsFound.length) { // TODO: Why participantsFound[0]
    // if (!participantsFound.length) {
      await getParticipantInfo({ commit, state }, message.participants[i])
    }
  }
}

export const loadMessages = async ({ commit, state }, data) => {
  try {
    const res = await fetchMessages()
    // const messages = res.data.results
    // for (let i = 0; i < messages.length; i++) {
    //   await loadAvatars({ commit, state }, messages[i])
    // }
    commit('MY_MESSAGES', res.data)
    return res.data
  } catch (err) {
    console.log('loadMessages error:', err)
  }
}

export const getMessageThreadCount = async ({ commit, state }, data) => {
  try {
    const res = await fetchMessageThreadCount(data)
    return res.data
  } catch (err) {
    console.log('getMessageThreadCount error:', err)
  }
}

export const loadMessageThread = async ({ commit }, data) => {
  try {
    const res = await fetchMessageThread(data.messageId, data.skip)
    commit('MY_MESSAGE_THREAD', res.data)
    return res.data
  } catch (err) {
    console.log('loadMessageThread error:', err)
  }
}

export const getParticipantInfo = async ({ commit }, data) => {
  try {
    const res = await fetchParticipantInfo(data)
    commit('MESSAGE_THREAD_PARTICIPANTS', res.data)
    return res.data
  } catch (err) {
    console.log('getParticipantInfo error:', err)
  }
}

export const participantConsent = async ({ commit }, data) => {
  try {
    const res = await fetchParticipantConsent(data)
    commit('PARTICIPANTS_CONSENT', res.data)
    return res.data
  } catch (err) {
    console.log('getParticipantConsent error:', err)
  }
}

export const addNewMessage = ({ commit, state }, data) => {
  if (data) {
    data.message.threadId = data.topic.split(':').pop()
    commit('ADD_NEW_MESSAGE', data)
  }
}

export const doSendMessage = async ({ commit, state }, payload) => {
  try {
    await sendMessage(payload)
    commit('UPDATE_SKIP', 1)
  } catch (err) {
    console.log('doSendMessage error:', err)
  }
}

export const updateMessage = async ({ commit, state }, data) => {
  try {
    const res = await updatemessage(data)
    commit('UPDATE_MESSAGE_IN_THREAD', res.data)
    return res.data
  } catch (err) {
    console.log('updateMessage error:', err)
  }
}

export const updateUnread = ({ commit, state }, data) => {
  commit('UPDATE_UNREAD', data)
}

export const addNewSignup = ({ commit, state }, data) => {
  if (data) {
    commit('ADD_NEW_SIGN_UP', data)
  }
}
export const handleNewSocketMessage = ({ commit, state }, data) => {
  if (data && data.topic) {
    switch (true) {
      case /nutricom.MessagingParticipant:state:chatting*/.test(data.topic):
        addNewMessage({ commit, state }, data)
        break

      case /nutricom.SignupListener:state:listening*/.test(data.topic):
        addNewSignup({ commit, state }, data.message)
        break
    }
  }
}

export const updateConsent = async ({ commit, state }, data) => {
  try {
    const res = await updatemyconsents(data)
    return res.data
  } catch (err) {
    console.log('updatemyconsents error:', err)
  }
}



// WEBPACK FOOTER //
// ./src/app/store/messaging/actions.js